import { Textarea, Button, CIInfoIcon, accessToken } from 'ccs-ui-components';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import axios from 'axios';
import { HELP_CENTER_CHATPAGE_SERVICE_BASE_URL, SERVICE_DETAILS_MAXLENGTH } from '../../../../../constants';
import { IServiceDetailsValidationModel } from '../../../../../models';

interface IServiceDescriptionProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  formData: IServiceDetailsValidationModel;
  isViewMode: boolean;
  setFormParamValues?: (callback: (prevState: IServiceDetailsValidationModel) => IServiceDetailsValidationModel) => void;
}
const ServiceDescription = ({
  handleInputChange,
  formData,
  isViewMode,
  setFormParamValues
}: IServiceDescriptionProps) => {
  const { t: translate } = useTranslation();
  const [isGeneratingDescription, setIsGeneratingDescription] = useState(false);
  const HELPER_TEXT = {
    desc_ht: translate('helper_text.txt_desc_ht')
  };

  const handleSuggestServiceDescriptionClick = async () => {
    if (!formData.serviceName.value) {
      return;
    }
    setIsGeneratingDescription(true);
    try {
      const serviceName = formData.serviceName.value;
      console.log('Service name for description:', serviceName);
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken.value}`,
      };
      const apiUrl = `${HELP_CENTER_CHATPAGE_SERVICE_BASE_URL}/generate-service-description?service_name=${serviceName}`;
      const response = await axios.get(apiUrl, { headers });
      if (response.data?.description && setFormParamValues) {
        setFormParamValues((previousState) => {
          const data = structuredClone(previousState);
          data.serviceDescription.value = response.data.description.trim();
          data.serviceDescription.isValid = true;
          data.serviceDescription.isTouched = true;
          return data;
        });
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error generating AI suggestion. Please try again.');
    } finally {
      setIsGeneratingDescription(false);
    }
  };

  return (
    <Form.Group className="mb-3" controlId="formServiceDescription">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <label htmlFor="serviceDescription">{String(translate('service_details_form_component.lbl_service_description'))}</label>
        {!isViewMode && (
          <div className="jolt-config-beta-link">
            <div className="button-group">
              <Button
                variant="tertiary"
                className="configure-jolt-btn"
                onClick={handleSuggestServiceDescriptionClick}
                disabled={!formData.serviceName.value || isGeneratingDescription}
                data-testid="suggest-service-description-btn"
              >
                <small>{isGeneratingDescription ? 'Generating...' : 'Suggest Service Description'}</small>
                <CIInfoIcon iconTxt={String(!formData.serviceName.value ? 'Enter service name first' : 'Get AI suggestion for service description')} />
              </Button>
              <span className="btn-beta-text">[Beta]</span>
            </div>
          </div>
        )}
      </div>
      <Textarea
        infoIconTxt={String(translate('service_details_form_component.description_info_bubble'))}
        type="text"
        name="serviceDescription"
        value={formData.serviceDescription.value}
        onChange={handleInputChange}
        error={!formData.serviceDescription.isValid}
        placeholder={
          !isViewMode
            ? String(
              translate(
                'service_details_form_component.plchd_service_description'
              )
            )
            : ''
        }
        label=""
        maxLength={SERVICE_DETAILS_MAXLENGTH.serviceDescMaxLength}
        data-testid="service-Description-input"
        helperText={HELPER_TEXT.desc_ht}
        errorTxt={!isViewMode ? formData.serviceDescription.error : ''}
      />
    </Form.Group>
  );
};

// Add default props to fix ESLint error
ServiceDescription.defaultProps = {
  setFormParamValues: undefined
};

export default ServiceDescription;
